import { Component, LOCALE_ID, Inject, ViewChild, ElementRef, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from "./footer/footer.component";
import { MenuComponent } from "./menu/menu.component";
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import localeEn from '@angular/common/locales/en';
import { AuthService } from '../services/auth.service';

registerLocaleData(localeEsAr);
registerLocaleData(localeEn);

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, MenuComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  @ViewChild('content') content!: ElementRef;
  // private router = inject(Router);
  // private activatedRoute = inject(ActivatedRoute);

  constructor(@Inject(LOCALE_ID) public locale: string, private translate: TranslateService, private authService: AuthService) {
    // console.log('app start:');
    // console.log('LOCALE_ID:', locale);
    // console.log('localeEsAr:', localeEsAr);
    // console.log('localeEn:', localeEn);
    this.translate.addLangs(['es-AR', 'en-US']);
    this.translate.setFallbackLang('es-AR');
    this.translate.use('es-AR');
  }

  ngOnInit() {
    //.log(this.mainSection);
    // this.activatedRoute.url.subscribe(url => {
    // });
  }

  ngAfterViewInit() {
    // 320px es el ancho del header + footer
    if(this.authService.isAdminPath()) {
      (this.content.nativeElement as HTMLElement).style.minHeight = `${window.innerHeight - 173}px`;
    } else {
      (this.content.nativeElement as HTMLElement).style.minHeight = `${window.innerHeight - 320}px`;
    }
  }

  isAdminPath(): boolean {
    return this.authService.isAdminPath();
  }

}
